<template>
    <div class="resource-summary flex" v-if="content" :class="[content.type, content.contentType]">
        <div class="ff">
            <div class="flex">
                <div class="resource-type">{{type}}</div>
            </div>
            <router-link tag="h3" class="resource-title resource-color-label" :class="color" :to="{name: 'resource', params: {resource: content.id}}">
                {{content.title}}
            </router-link>
            <div class="resource-description" v-if="content.metadata.description">
                {{content.metadata.description}}
            </div>
            <template v-if="content.contentType === 'video'">
                <video
                    preload="metadata"
                    crossorigin="anonymous"
                    controls
                    controlsList="nodownload"
                    @contextmenu.prevent
                    @mousedown.right.prevent
                >
                <source :src="content.metadata.url" type="video/mp4" />
            </video>
            </template>
            <template v-else-if="content.contentType === 'annotation'">
                <div class="annotation-preview">
                    <img :src="content.data.backgrounds[0].url" />
                </div>
            </template>
            <template v-else-if="content.contentType === 'pdf' || content.type === 'page' || content.type === 'lesson' || content.type === 'assignment'">
                <div class="thumbnails flex flex-wrap" v-if="thumbnails.length">
                    <router-link class="thumbnail block" v-for="thumbnail of thumbnails" :key="thumbnail" :to="{name: 'resource', params: {resource: content.id}}">
                        <img class="block" :src="thumbnail" />
                    </router-link>
                </div>
            </template>
            <template v-else-if="content.contentType === 'website'">
                <div class="flex">
                    <a :href="content.metadata.url" target="_blank" class="button external flex flex-align">
                        Open Website
                        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-external-link" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z"/>
                            <path d="M11 7h-5a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-5" />
                            <line x1="10" y1="14" x2="20" y2="4" />
                            <polyline points="15 4 20 4 20 9" />
                        </svg>
                    </a>
                </div>
            </template>
            <template v-if="content.attachments">
                <!-- <attachment v-for="attachment of content.attachments" :key="attachment.id" :content="attachment" /> -->
            </template>
        </div>
        <div class="resource-summary-thumbnail" v-if="content.metadata.thumbnail && !this.content.data.thumbnails">
            <img :src="content.metadata.thumbnail" />
        </div>
    </div>
</template>

<script>
    import { get } from 'lodash';
    import Assign from '@/components/modals/Assign.vue';

    const types = {
        lesson: 'Lesson',
        assignment: 'Assignment',
        library: 'Folder',
        quiz: 'Assessment',
        deliverable: 'Deliverable',
        page: 'Single Page',
        custom: 'Custom Resource',
        curriculum: 'Curriculum',
        collection: 'Resource Collection',
        'curriculum-map': 'Curriculum Map',
        lessonPlan: 'Lesson Plan',
        'multiple-choice': 'Multiple Choice',
        'true-false': 'True / False',
        'text-response': 'Text Response',
        'select-multiple': 'Select Multiple',
        'choice-matrix': 'Choice Matrix',
        'answer-matrix': 'Answer Matrix',
        'image-response': 'Image Response',
        'audio-response': 'Audio Response',
        powerpoint: 'PowerPoint',
        cloze: 'Fill In The Blank',
        image: 'Image',
        pdf: 'PDF',
        video: 'Video',
        embed: 'Embed',
        webm: 'WebM Video',
        doc: 'Document',
        website: 'Website'
    };

    export default {
        name: 'ResourceSummary',
        props: {
            content: Object
        },
        data(){
            return {

            };
        },
        computed: {
            color(){
                const color = _.get(this, 'content.metadata.color', '') === 'none' ? '' : _.get(this, 'content.metadata.color', '');
                return color;
            },
            product(){
                return this.$store.getters.product;
            },
            type(){
                if(types.hasOwnProperty(this.content.displayType)){
                    return types[this.content.displayType];
                }

                if(types.hasOwnProperty(this.content.contentType)){
                    return types[this.content.contentType];
                }

                if(types.hasOwnProperty(this.content.type)){
                    return types[this.content.type];
                }

                return 'Item';
            },
            thumbnails(){
                if(this.content.data.thumbnails){
                    return this.content.data.thumbnails.slice(0, 5);
                }else if(this.content.data.thumbnail){
                    return [this.content.data.thumbnail];
                }else{
                    return [];
                }
            }
        },
        methods: {
            assign(chapter){
                this.$modal.show(Assign, {chapter}, {width: 700, height: 'auto', classes: 'modal'});
            },
            highlight(title){
                if(this.search){
                    return title.replace(this.search, `<span class="highlight">${this.search}</span>`);
                }

                return title;
            }
        }
    }
</script>

<style lang="less">
    @import "~@/assets/less/variables";

    .resource-summary
    {
        max-width: 800px;
        padding: 50px 0;
        border-bottom: 1px solid @e4;

        .resource-type
        {
            padding: 2px 8px;
            height: 22px;
            line-height: 18px;
            border-radius: 15px;
            font-size: 12px;
            font-weight: 600;
            white-space: nowrap;
            text-transform: uppercase;
            background: fade(@base, 20%);
            color: @base;
        }

        .resource-title
        {
            font-size: 22px;
            line-height: 26px;
            margin: 12px 0 6px;
            cursor: pointer;
            transition: opacity ease 0.2s;

            &:hover, &:active
            {
                opacity: 0.5;
            }
        }

        .resource-description
        {
            font-size: 15px;
            line-height: 20px;
            margin-bottom: 20px;
            color: @grey;
        }

        .button.external
        {
            padding-right: 12px;

            .icon
            {
                width: 19px;
                margin-left: 10px;
            }
        }

        .thumbnails
        {
            margin-top: 20px;
        }

        .thumbnail
        {
            width: 120px;
            height: 120px;
            box-shadow: 0 3px 10px -2px rgba(0, 0, 0, 0.2), 0 1px 3px rgba(0, 0, 0, 0.1);
            margin-right: 20px;
            border-radius: 5px;
            overflow: hidden;
            margin-top: 20px;

            img
            {
                width: 120px;
                height: 120px;
                object-fit: cover;
            }
        }

        video
        {
            max-width: 800px;
            width: 100%;
            box-shadow: 0 6px 30px -2px rgba(0, 0, 0, 0.35);
            border-radius: 6px;
            margin-top: 40px;
        }

        .resource-summary-thumbnail
        {
            margin-left: 20px;

            img
            {
                width: 120px;
                height: 120px;
                border-radius: 6px;
                box-shadow: 0 6px 20px -2px rgba(0, 0, 0, 0.25);
                object-fit: cover;
            }
        }

        &.annotation
        {
            padding-bottom: 0;
            border-bottom: 0;

            .annotation-preview
            {
                max-width: 800px;
                border-radius: 6px;
                box-shadow: 0 4px 20px -2px rgba(0, 0, 0, 0.25);
                margin-top: 20px;
                pointer-events: none;

                img
                {
                    width: 100%;
                    object-fit: cover;
                }
            }
        }

        &.lesson, &.assignment, &.page
        {
            .resource-description
            {
                margin-bottom: 0;
            }
        }
    }
    .resource-color-label {
        &.green
        {
            color: @green-text;
        }

        &.blue
        {
            color: @blue-text;
        }
        &.gold
        {
            color: @gold-text;
        }

        &.magenta
        {
            color: @magenta-text;
        }
        &.red
        {
            color: @red;
        }

        &.orange
        {
            color: @orange;
        }

        &.yellow
        {
            color: @yellow;
        }
    }
</style>
